/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * data security, extended fields are encrypted using the specified algorithm
   */
  security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class UcrService {
  /**
   *
   */
  static medorgsWebControllerOne(
    params: {
      /** Идентификатор организации */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedorgWithCountersAndToken> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/medorgs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static medorgsWebControllerUpdate(
    params: {
      /** Идентификатор организации */
      id: string;
      /** requestBody */
      body?: UpdateMedOrgCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedOrg> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/medorgs/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static medorgsWebControllerList(
    params: {
      /** Количество элементов на странице */
      limit: number;
      /** Сдвиг */
      offset: number;
      /** Строка поиска */
      search?: string;
      /** Тип организации */
      type?: string;
      /** Айди типа медизделия по которому нужно получить статистику: кол-во изделий у МО и доступность данного типа меддевайса */
      statsMeddeviceTypeId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedOrgsList> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/medorgs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        limit: params['limit'],
        offset: params['offset'],
        search: params['search'],
        type: params['type'],
        statsMeddeviceTypeId: params['statsMeddeviceTypeId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static medorgsWebControllerAdd(
    params: {
      /** requestBody */
      body?: AddMedOrgCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedorgWithApiToken> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/medorgs';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static medorgsWebControllerSetStatus(
    params: {
      /** Идентификатор организации */
      id: string;
      /** requestBody */
      body?: SetMedorgStatusCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedOrg> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/medorgs/{id}/status';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerOne(
    params: {
      /** Идентификатор типа МИ */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MeddeviceTypeExtended> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerUpdate(
    params: {
      /** Идентификатор типа МИ */
      id: string;
      /** requestBody */
      body?: UpdateMedDeviceTypeCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MeddeviceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerGetMedorgsOfMeddeviceType(
    params: {
      /** Идентификатор типа МИ */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedorgStatsList> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types/{id}/medorg_stats';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerList(
    params: {
      /** Количество элементов на странице */
      limit: number;
      /** Сдвиг */
      offset: number;
      /** Строка поиска */
      search?: string;
      /** Ответственная медорганизация */
      medorgId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedDeviceTypesList> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        limit: params['limit'],
        offset: params['offset'],
        search: params['search'],
        medorgId: params['medorgId']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerAdd(
    params: {
      /** requestBody */
      body?: AddMedDeviceTypeWebCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MeddeviceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerSetStatus(
    params: {
      /** Идентификатор типа МИ */
      id: string;
      /** requestBody */
      body?: SetMedDeviceTypeStatusCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MeddeviceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types/{id}/status';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerAssignMedorg(
    params: {
      /** Идентификатор типа МИ */
      id: string;
      /** requestBody */
      body?: AddAvailableMedorg;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MeddeviceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types/{id}/assign';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddeviceTypesWebControllerUnassignMedorg(
    params: {
      /** Идентификатор типа МИ */
      id: string;
      /** requestBody */
      body?: AddAvailableMedorg;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MeddeviceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types/{id}/unassign';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static softwareWebControllerAddSoftwareVersion(
    params: {
      /** Идентификатор типа МИ */
      id: string;
      /** requestBody */
      body?: AddSoftwareVersionCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MeddeviceType> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevice_types/{id}/software_version';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddevicesWebControllerOne(
    params: {
      /** Идентификатор экземпляра медицинского изделия (МИ) */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Meddevice> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevices/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddevicesWebControllerUpdate(
    params: {
      /** Идентификатор экземпляра медицинского изделия (МИ) */
      id: string;
      /** requestBody */
      body?: UpdateMedDeviceCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Meddevice> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevices/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddevicesWebControllerList(
    params: {
      /** Количество элементов на странице */
      limit: number;
      /** Сдвиг */
      offset: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MedDevicesList> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevices';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { limit: params['limit'], offset: params['offset'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddevicesWebControllerAdd(
    params: {
      /** requestBody */
      body?: AddMeddeviceForMedorgCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Meddevice> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevices';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddevicesWebControllerAddV2(
    params: {
      /** requestBody */
      body?: AddMeddeviceForMedorgCommandV2;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Meddevice> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v2/meddevices';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddevicesWebControllerSetStatus(
    params: {
      /** Идентификатор экземпляра медицинского изделия (МИ) */
      id: string;
      /** requestBody */
      body?: SetMedDeviceStatusCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Meddevice> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevices/{id}/status';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static meddevicesWebControllerAddVerification(
    params: {
      /** Идентификатор экземпляра медицинского изделия (МИ) */
      id: string;
      /** requestBody */
      body?: AddVerificationCommand;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Meddevice> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/meddevices/{id}/verifications';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static usersWebControllerAdd(
    params: {
      /** requestBody */
      body?: AddUserRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/users';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static usersWebControllerGetList(
    params: {
      /** Количество элементов на странице */
      limit: number;
      /** Сдвиг */
      offset: number;
      /** Строка поиска */
      search?: string;
      /** Фильтр по ролям */
      roleKeys?: any | null[];
      /** Фильтр по организациям */
      orgUnitsIds?: any | null[];
      /** Фильтр по статусу пользователя */
      statuses?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetUserResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/users';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        limit: params['limit'],
        offset: params['offset'],
        search: params['search'],
        roleKeys: params['roleKeys'],
        orgUnitsIds: params['orgUnitsIds'],
        statuses: params['statuses']
      };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static usersWebControllerUpdate(
    params: {
      /** Идентификатор */
      id: string;
      /** requestBody */
      body?: UpdateUserRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/users/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('patch', 'application/json', url, options);

      /** 适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body */

      console.warn('适配移动开发（iOS13 等版本），只有 POST、PUT 等请求允许带body');

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static usersWebControllerChangeStatus(
    params: {
      /** Идентификатор */
      id: string;
      /** requestBody */
      body?: ChangeStatusRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Success> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/users/{id}/change-status';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static authWebControllerLogin(
    params: {
      /** requestBody */
      body?: LoginRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LoginResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/auth/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static authWebControllerLogOut(options: IRequestOptions = {}): Promise<LoginResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/auth/logout';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static authWebControllerSetPassword(
    params: {
      /** requestBody */
      body?: SetPasswordRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Success> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/auth/set-password';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static authWebControllerCheckResetPasswordToken(
    params: {
      /** Идентификатор ссылки для установки пароля. */
      resetPasswordId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Success> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/auth/check-reset-password-link';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { resetPasswordId: params['resetPasswordId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static authWebControllerResetPassword(
    params: {
      /** requestBody */
      body?: ResetPasswordRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Success> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/auth/reset-password';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static datalensControllerWebList(options: IRequestOptions = {}): Promise<DatalensReports> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/datalens/reports';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static datalensControllerWebOne(
    params: {
      /** Идентификатор дашборда из datalens */
      sourceId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Dashboard> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/web/v1/datalens/reports/{sourceId}';
      url = url.replace('{sourceId}', params['sourceId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export interface LegalEntity {
  /** Тип контрагента: юридическое лицо, ИП, самозанятый гражданин */
  type: EnumLegalEntityType;

  /** Статус контрагента */
  isEnabled: boolean;

  /** Наименование контрагента (по возможности сокращено) */
  displayName: string;

  /** Идентификатор юридического лица */
  id: string;

  /** Полное наименование организации */
  name: string;

  /** Краткое (до 500 символов) наименование организации. Не используется при формировании ЭПЛ. */
  shortname?: string;

  /** ИНН юр. лица (10 цифр) */
  inn?: string;

  /** КПП юр. лица (9 цифр) */
  kpp?: string;

  /** ОГРН юр. лица (13 цифр) */
  ogrn: string;
}

export interface Fullname {
  /** Имя (до 60 символов) */
  name: string;

  /** Фамилия (до 60 символов) */
  surname: string;

  /** Отчество (до 60 символов) */
  patronymic?: string;
}

export interface IndividualEntrepreneur {
  /** Тип контрагента: юридическое лицо, ИП, самозанятый гражданин */
  type: EnumIndividualEntrepreneurType;

  /** Статус контрагента */
  isEnabled: boolean;

  /** Наименование контрагента (по возможности сокращено) */
  displayName: string;

  /** Идентификатор индивидуального предпринимателя */
  id: string;

  /** Полное имя индивидуального предпринимателя */
  fullname: CombinedFullnameTypes;

  /** ОГРНИП (15 цифр) */
  ogrnip: string;

  /** ИНН физического лица (12 цифр) */
  inn?: string;
}

export interface SelfEmployed {
  /** Тип контрагента: юридическое лицо, ИП, самозанятый гражданин */
  type: EnumSelfEmployedType;

  /** Статус контрагента */
  isEnabled: boolean;

  /** Наименование контрагента (по возможности сокращено) */
  displayName: string;

  /** Идентификатор самозанятого гражданина */
  id: string;

  /** Полное имя самозанятого гражданина */
  fullname: CombinedFullnameTypes;

  /** ИНН физического лица (12 цифр) */
  inn: string;
}

export interface LegalEntityInfo {
  /** Полное наименование организации */
  name: string;

  /** Краткое (до 500 символов) наименование организации. Не используется при формировании ЭПЛ. */
  shortname?: string;

  /** ИНН юр. лица (10 цифр) */
  inn?: string;

  /** КПП юр. лица (9 цифр) */
  kpp?: string;

  /** ОГРН юр. лица (13 цифр) */
  ogrn: string;
}

export interface IndividualEntrepreneurInfo {
  /** Полное имя индивидуального предпринимателя */
  fullname: CombinedFullnameTypes;

  /** ОГРНИП (15 цифр) */
  ogrnip: string;

  /** ИНН физического лица (12 цифр) */
  inn?: string;
}

export interface SelfEmployedInfo {
  /** Полное имя самозанятого гражданина */
  fullname: CombinedFullnameTypes;

  /** ИНН физического лица (12 цифр) */
  inn: string;
}

export interface BillingInfo {
  /** Наименование банка */
  bank: string;

  /** БИК (9 цифр) */
  bik: string;

  /** Расчётный счёт (20 цифр) */
  checkingAccount: string;

  /** Корреспондентский счёт (20 цифр) */
  correspondentAccount: string;
}

export interface MedLicense {
  /** Серия лицензии на ведение медицинской деятельности (60 символов) */
  series: string;

  /** Номер лицензии на ведение медицинской деятельности (до 60 символов) */
  number: string;

  /** Дата выдачи */
  issuedAt: Date;

  /** Дата истечения */
  expiresAt?: Date;
}

export interface Contact {
  /** Идентификатор контактного лица */
  id: string;

  /** Полное имя контактного лица */
  fullname: CombinedFullnameTypes;

  /** Статус контактного лица */
  isEnabled: boolean;

  /** Должность */
  position?: string;

  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email: string;

  /** Контактный телефон в формате +7XXXXXXXXXX */
  phone?: string;
}

export interface PickTypeClass {
  /** Признак доступности типа МИ для медицинской организации */
  isAvailable: boolean;

  /** Количество устройств типа МИ в медицинской организации */
  count: number;
}

export interface Counters {
  /** Количество медработников, числящихся в организации */
  medics: number;

  /** Количество доступных медицинских изделий */
  meddevices: number;

  /** [NO DESCRIPTION] */
  statsByMeddeviceTypeId?: CombinedStatsByMeddeviceTypeIdTypes;
}

export interface MedorgWithCountersAndToken {
  /** Идентификатор организации */
  id: string;

  /** Идентификационная информация медицинской организации */
  info: AllInfoTypes;

  /** Тип медорганизации */
  type: EnumMedorgWithCountersAndTokenType;

  /** Данные для выставления счетов */
  billing?: CombinedBillingTypes;

  /** Лицензия на ведение медицинской деятельности */
  license: CombinedLicenseTypes;

  /** [Массив] Контактные лица */
  contacts: Contact[];

  /** Счетчики медицинской организации */
  counters: CombinedCountersTypes;

  /** Токен для доступа к API */
  apiToken: string;
}

export interface MedorgWithCounters {
  /** Идентификатор организации */
  id: string;

  /** Идентификационная информация медицинской организации */
  info: AllInfoTypes;

  /** Тип медорганизации */
  type: EnumMedorgWithCountersType;

  /** Данные для выставления счетов */
  billing?: CombinedBillingTypes;

  /** Лицензия на ведение медицинской деятельности */
  license: CombinedLicenseTypes;

  /** [Массив] Контактные лица */
  contacts: Contact[];

  /** Счетчики медицинской организации */
  counters: CombinedCountersTypes;
}

export interface MedOrgsList {
  /** Общее количество найденных элементов */
  total: number;

  /** [Массив] Найденные медицинские организации */
  medOrgs: MedorgWithCounters[];
}

export interface ContactInfo {
  /** Полное имя контактного лица */
  fullname: CombinedFullnameTypes;

  /** Должность */
  position?: string;

  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email: string;

  /** Контактный телефон в формате +7XXXXXXXXXX */
  phone?: string;
}

export interface AddMedOrgCommand {
  /** Данные для выставления счетов */
  billing?: CombinedBillingTypes;

  /** Лицензия на ведение медицинской деятельности */
  license: CombinedLicenseTypes;

  /** Идентификационная информация медицинской организации */
  oneOfInfo: AllOneOfInfoTypes;

  /** [Массив] Контактные лица */
  contacts: ContactInfo[];
}

export interface MedorgWithApiToken {
  /** Идентификатор организации */
  id: string;

  /** Идентификационная информация медицинской организации */
  info: AllInfoTypes;

  /** Тип медорганизации */
  type: EnumMedorgWithApiTokenType;

  /** Данные для выставления счетов */
  billing?: CombinedBillingTypes;

  /** Лицензия на ведение медицинской деятельности */
  license: CombinedLicenseTypes;

  /** [Массив] Контактные лица */
  contacts: Contact[];

  /** Токен для доступа к API */
  apiToken: string;
}

export interface UpdateLegalEntityInfo {
  /** Полное наименование организации */
  name?: string;

  /** КПП юр. лица (9 цифр) */
  kpp?: string;
}

export interface UpdateIndividualEntrepreneurInfo {
  /** Полное имя индивидуального предпринимателя */
  fullname?: CombinedFullnameTypes;
}

export interface UpdateMedOrgCommand {
  /** Данные для выставления счетов */
  billing?: CombinedBillingTypes;

  /** Изменяемые данные компании */
  legalEntityInfo?: CombinedLegalEntityInfoTypes;

  /** Изменяемые данные ИП */
  individualEntrepreneurInfo?: CombinedIndividualEntrepreneurInfoTypes;

  /** [Массив] Контактные лица */
  contacts?: ContactInfo[];

  /** Лицензия на ведение медицинской деятельности */
  license?: CombinedLicenseTypes;
}

export interface MedOrg {
  /** Идентификатор организации */
  id: string;

  /** Идентификационная информация медицинской организации */
  info: AllInfoTypes;

  /** Тип медорганизации */
  type: EnumMedOrgType;

  /** Данные для выставления счетов */
  billing?: CombinedBillingTypes;

  /** Лицензия на ведение медицинской деятельности */
  license: CombinedLicenseTypes;

  /** [Массив] Контактные лица */
  contacts: Contact[];
}

export interface SetMedorgStatusCommand {
  /** Статус медицинской организации */
  isEnabled: boolean;
}

export interface MeasurerType {
  /** Регистрационный номер типа средства измерения (СИ) */
  regNumber: string;

  /** Наименование средства типа измерения (СИ) */
  name: string;

  /** Обозначение средства типа измерения (СИ) */
  label: string;
}

export interface ConditionRequirements {
  /** Температура окружающей среды в градусах Цельсия */
  temperatureMin: number;

  /** Температура окружающей среды в градусах Цельсия */
  temperatureMax: number;

  /** Влажность окружающей среды в процентах */
  humidityMin: number;

  /** Влажность окружающей среды в процентах */
  humidityMax: number;

  /** Освещённость в люксах */
  illuminationMin: number;

  /** Освещённость в люксах */
  illuminationMax: number;
}

export interface Checksum {
  /** Путь к файлу на файловой системе */
  path: string;

  /** Алгоритм расчёта контрольной суммы */
  algorithm: string;

  /** Контрольная сумма файла */
  value: string;
}

export interface SoftwareInfoWithCreateDate {
  /** Версия программного обеспечения */
  version: string;

  /** [Массив] Информация об исполняемых файлах ПО */
  checksums: Checksum[];

  /** Дата создания */
  createdAt: Date;
}

export interface MeddeviceTypeExtended {
  /** Идентификатор типа МИ */
  id: string;

  /** Наименование типа медицинского изделия (МИ) */
  name: string;

  /** Регистрационный номер типа медицинского изделия (МИ) */
  regNumber: string;

  /** Информация о типа СИ */
  measurerType: CombinedMeasurerTypeTypes;

  /** Допустимые условия измерений */
  conditions: CombinedConditionsTypes;

  /** Признак наличия функции одновременного измерения уровня алкоголя и температуры */
  simultaneousThermoAlco: boolean;

  /** Статус типа МИ */
  isEnabled: boolean;

  /** Дата создания */
  createdAt: Date;

  /** Информация об ответственной мед организации */
  counterparty?: AllCounterpartyTypes;

  /** [Массив] Информация об эталонных контрольных суммах ПО МИ */
  software: SoftwareInfoWithCreateDate[];
}

export interface MedorgStats {
  /** Информация о медицинской организации */
  medorg: CombinedMedorgTypes;

  /** Признак доступности типа МИ для медицинской организации */
  isAvailable: boolean;

  /** Количество устройств типа МИ в медицинской организации */
  count: number;
}

export interface MedorgStatsList {
  /** [Массив] Кол-во изделий с данным типом и доступность для ОУ данного типа */
  items: MedorgStats[];
}

export interface MedDeviceTypesList {
  /** [Массив] Найденные типы медицинских изделий (МИ) */
  meddeviceTypes: MeddeviceTypeExtended[];

  /** Общее количество найденных элементов */
  total: number;
}

export interface SoftwareInfo {
  /** Версия программного обеспечения */
  version: string;

  /** [Массив] Информация об исполняемых файлах ПО */
  checksums: Checksum[];
}

export interface AddMedDeviceTypeWebCommand {
  /** Наименование типа медицинского изделия (МИ) */
  name: string;

  /** Регистрационный номер типа медицинского изделия (МИ) */
  regNumber: string;

  /** Информация о типа СИ */
  measurerType: CombinedMeasurerTypeTypes;

  /** Допустимые условия измерений */
  conditions: CombinedConditionsTypes;

  /** Признак наличия функции одновременного измерения уровня алкоголя и температуры */
  simultaneousThermoAlco: boolean;

  /** [Массив] Информация об эталонных контрольных суммах ПО МИ */
  software: SoftwareInfo[];

  /** Идентификатор ответственной медицинской организации */
  medorgId: string;
}

export interface MeddeviceType {
  /** Идентификатор типа МИ */
  id: string;

  /** Наименование типа медицинского изделия (МИ) */
  name: string;

  /** Регистрационный номер типа медицинского изделия (МИ) */
  regNumber: string;

  /** Информация о типа СИ */
  measurerType: CombinedMeasurerTypeTypes;

  /** Допустимые условия измерений */
  conditions: CombinedConditionsTypes;

  /** Признак наличия функции одновременного измерения уровня алкоголя и температуры */
  simultaneousThermoAlco: boolean;

  /** Статус типа МИ */
  isEnabled: boolean;

  /** [Массив] Информация об эталонных контрольных суммах ПО МИ */
  software: SoftwareInfo[];
}

export interface UpdateMedDeviceTypeCommand {
  /** Наименование типа медицинского изделия (МИ) */
  name: string;

  /** Регистрационный номер типа медицинского изделия (МИ) */
  regNumber: string;

  /** Информация о типа СИ */
  measurerType: CombinedMeasurerTypeTypes;

  /** Допустимые условия измерений */
  conditions: CombinedConditionsTypes;

  /** Признак наличия функции одновременного измерения уровня алкоголя и температуры */
  simultaneousThermoAlco: boolean;

  /** Идентификатор ответственной медицинской организации */
  medorgId?: string;
}

export interface SetMedDeviceTypeStatusCommand {
  /** Статус типа медицинского изделия (МИ) */
  isEnabled: boolean;
}

export interface AddAvailableMedorg {
  /** Идентификатор ответственной медицинской организации */
  medorgIds: string[];
}

export interface AddSoftwareVersionCommand {
  /** Версия программного обеспечения */
  version: string;

  /** [Массив] Информация об исполняемых файлах ПО */
  checksums: Checksum[];
}

export interface VerificationInfo {
  /** Модификация средства измерения (СИ) */
  measurerModification: string;

  /** Тип поверки. Одно из значений перечисления: initial,periodic,unscheduled,inspection,unspecified */
  type: EnumVerificationInfoType;

  /** Дата поверки */
  date: Date;

  /** Дата окончания срока действия поверки */
  dueDate: Date;

  /** Наименование организации поверителя */
  authority: string;

  /** Признак пригодности средства измерения (СИ) */
  result: boolean;
}

export interface Verification {
  /** Номер свидетельства о поверке МИ */
  certificateNumber: string;

  /** Информация о поверке из ФГИС "Аршин". Может отсутствовать, если данные ещё не загружены в систему. */
  info?: CombinedInfoTypes;
}

export interface Meddevice {
  /** Идентификатор экземпляра медицинского изделия (МИ) */
  id: string;

  /** Идентификатор медицинской организации */
  medorgId: string;

  /** Идентификатор типа МИ */
  typeId: string;

  /** Заводской номер МИ */
  serial: string;

  /** Статус МИ */
  isEnabled: boolean;

  /** [Массив] Информация о поверках */
  verifications: Verification[];

  /** Сценарий использования МИ (стационарный не предполагает частой смены местоположения) */
  usageScenario: EnumMeddeviceUsageScenario;

  /** Дата и время регистрации устройства */
  registeredAt: Date;
}

export interface MedDevicesList {
  /** Общее количество найденных элементов */
  total: number;

  /** [Массив] Найденные медицинские изделия */
  meddevices: Meddevice[];
}

export interface AddMeddeviceDto {
  /** Номер свидетельства о поверке МИ */
  certificateNumber: string;
}

export interface AddMeddeviceForMedorgCommand {
  /** Идентификатор медицинской организации */
  medorgId: string;

  /** Идентификатор типа МИ */
  typeId: string;

  /** Заводской номер МИ */
  serial: string;

  /** Сценарий использования МИ (стационарный не предполагает частой смены местоположения) */
  usageScenario: EnumAddMeddeviceForMedorgCommandUsageScenario;

  /** Информация о поверке ПАК */
  verification?: CombinedVerificationTypes;
}

export interface AddMeddeviceForMedorgCommandV2 {
  /** Идентификатор медицинской организации */
  medorgId: string;

  /** Идентификатор типа МИ */
  typeId: string;

  /** Заводской номер МИ */
  serial: string;

  /** Сценарий использования МИ (стационарный не предполагает частой смены местоположения) */
  usageScenario: EnumAddMeddeviceForMedorgCommandV2UsageScenario;
}

export interface UpdateMedDeviceCommand {
  /** Заводской номер МИ */
  serial: string;

  /** Сценарий использования МИ (стационарный не предполагает частой смены местоположения) */
  usageScenario: EnumUpdateMedDeviceCommandUsageScenario;
}

export interface SetMedDeviceStatusCommand {
  /** Статус медицинского изделия */
  isEnabled: boolean;
}

export interface AddVerificationCommand {
  /** Номер свидетельства о поверке МИ */
  certificateNumber: string;
}

export interface AddUserRequest {
  /** Имя (до 60 символов) */
  name: string;

  /** Фамилия (до 60 символов) */
  surname: string;

  /** Отчество (до 60 символов) */
  patronymic?: string;

  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email: string;

  /** Контактный телефон в формате +7XXXXXXXXXX */
  phone?: string;

  /** Идентификатор мед. организации */
  medorgId?: string;

  /** Ключ роли пользователя */
  roleKey: string;
}

export interface RoleDto {
  /** Ключ роли */
  key: string;

  /** Название роли */
  name: string;

  /** Описание роли */
  description: string;
}

export interface UserDto {
  /** Идентификатор пользователя */
  id: string;

  /** Имя (до 60 символов) */
  name: string;

  /** Фамилия (до 60 символов) */
  surname: string;

  /** Отчество (до 60 символов) */
  patronymic?: string;

  /** Статус активации аккаунта пользователя */
  status: EnumUserDtoStatus;

  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email: string;

  /** Контактный телефон в формате +7XXXXXXXXXX */
  phone?: string;

  /** Мед. организация пользователя */
  medorg?: CombinedMedorgTypes;

  /** Роль пользователя */
  role: CombinedRoleTypes;
}

export interface GetUserResponse {
  /** Общее количество найденных элементов */
  total: number;

  /** [Массив] Список пользователей */
  users: UserDto[];
}

export interface UpdateUserRequest {
  /** Имя (до 60 символов) */
  name?: string;

  /** Фамилия (до 60 символов) */
  surname?: string;

  /** Отчество (до 60 символов) */
  patronymic?: string;

  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email?: string;

  /** Контактный телефон в формате +7XXXXXXXXXX */
  phone?: string;
}

export interface ChangeStatusRequest {
  /** Статус активности пользователя */
  isActive: boolean;
}

export interface Success {
  /** Результат операции */
  success: boolean;
}

export interface LoginRequest {
  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email: string;

  /** Пароль пользователя. */
  password: string;
}

export interface LoginResponse {
  /** Идентификатор пользователя */
  id: string;

  /** Имя (до 60 символов) */
  name: string;

  /** Фамилия (до 60 символов) */
  surname: string;

  /** Отчество (до 60 символов) */
  patronymic?: string;

  /** Статус активации аккаунта пользователя */
  status: EnumLoginResponseStatus;

  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email: string;

  /** Контактный телефон в формате +7XXXXXXXXXX */
  phone?: string;

  /** Мед. организация пользователя */
  medorg?: CombinedMedorgTypes;

  /** Роль пользователя */
  role: CombinedRoleTypes;
}

export interface SetPasswordRequest {
  /** Идентификатор ссылки для установки пароля. */
  resetPasswordId: string;

  /** Пароль пользователя. */
  password: string;
}

export interface ResetPasswordRequest {
  /** Адрес электронной почты в стандартном формате (до 256 символов) */
  email: string;
}

export interface DatalensReport {
  /** Идентификатор дашборда */
  id: string;

  /** Идентификатор дашборда из datalens */
  sourceId: string;

  /** Название дашборда */
  title: string;

  /** Тип дашборда */
  type: EnumDatalensReportType;
}

export interface DatalensReports {
  /** [Массив] Список отчетов из datalens */
  reports: DatalensReport[];
}

export interface Dashboard {
  /** Идентификатор дашборда */
  id: string;

  /** Идентификатор дашборда из datalens */
  sourceId: string;

  /** Название дашборда */
  title: string;

  /** Тип дашборда */
  type: EnumDashboardType;

  /** Ссылка для получения дашборда из datalens */
  link: string;

  /** Дата рождения */
  linkExpiresAt: Date;

  /** Пермишен для получения дашборда */
  permission: string;
}
export enum EnumLegalEntityType {
  'legalEntity' = 'legalEntity',
  'individualEntrepreneur' = 'individualEntrepreneur',
  'selfEmployed' = 'selfEmployed'
}
export enum EnumIndividualEntrepreneurType {
  'legalEntity' = 'legalEntity',
  'individualEntrepreneur' = 'individualEntrepreneur',
  'selfEmployed' = 'selfEmployed'
}
export type CombinedFullnameTypes = Fullname;
export enum EnumSelfEmployedType {
  'legalEntity' = 'legalEntity',
  'individualEntrepreneur' = 'individualEntrepreneur',
  'selfEmployed' = 'selfEmployed'
}
export type CombinedStatsByMeddeviceTypeIdTypes = PickTypeClass;
export type AllInfoTypes = LegalEntity | IndividualEntrepreneur | SelfEmployed;
export enum EnumMedorgWithCountersAndTokenType {
  'legalEntity' = 'legalEntity',
  'individualEntrepreneur' = 'individualEntrepreneur',
  'selfEmployed' = 'selfEmployed'
}
export type CombinedBillingTypes = BillingInfo;
export type CombinedLicenseTypes = MedLicense;
export type CombinedCountersTypes = Counters;
export enum EnumMedorgWithCountersType {
  'legalEntity' = 'legalEntity',
  'individualEntrepreneur' = 'individualEntrepreneur',
  'selfEmployed' = 'selfEmployed'
}
export type AllOneOfInfoTypes = LegalEntityInfo | IndividualEntrepreneurInfo | SelfEmployedInfo;
export enum EnumMedorgWithApiTokenType {
  'legalEntity' = 'legalEntity',
  'individualEntrepreneur' = 'individualEntrepreneur',
  'selfEmployed' = 'selfEmployed'
}
export type CombinedLegalEntityInfoTypes = UpdateLegalEntityInfo;
export type CombinedIndividualEntrepreneurInfoTypes = UpdateIndividualEntrepreneurInfo;
export enum EnumMedOrgType {
  'legalEntity' = 'legalEntity',
  'individualEntrepreneur' = 'individualEntrepreneur',
  'selfEmployed' = 'selfEmployed'
}
export type CombinedMeasurerTypeTypes = MeasurerType;
export type CombinedConditionsTypes = ConditionRequirements;
export type AllCounterpartyTypes = LegalEntity | IndividualEntrepreneur | SelfEmployed;
export type CombinedMedorgTypes = MedOrg;
export enum EnumVerificationInfoType {
  'initial' = 'initial',
  'periodic' = 'periodic',
  'unscheduled' = 'unscheduled',
  'inspection' = 'inspection',
  'unspecified' = 'unspecified'
}
export type CombinedInfoTypes = VerificationInfo;
export enum EnumMeddeviceUsageScenario {
  'stationary' = 'stationary',
  'mobile' = 'mobile'
}
export enum EnumAddMeddeviceForMedorgCommandUsageScenario {
  'stationary' = 'stationary',
  'mobile' = 'mobile'
}
export type CombinedVerificationTypes = AddMeddeviceDto;
export enum EnumAddMeddeviceForMedorgCommandV2UsageScenario {
  'stationary' = 'stationary',
  'mobile' = 'mobile'
}
export enum EnumUpdateMedDeviceCommandUsageScenario {
  'stationary' = 'stationary',
  'mobile' = 'mobile'
}
export enum EnumUserDtoStatus {
  'ACTIVE' = 'ACTIVE',
  'WAITING_ACTIVATION' = 'WAITING_ACTIVATION',
  'DISABLED' = 'DISABLED'
}
export type CombinedRoleTypes = RoleDto;
export enum EnumLoginResponseStatus {
  'ACTIVE' = 'ACTIVE',
  'WAITING_ACTIVATION' = 'WAITING_ACTIVATION',
  'DISABLED' = 'DISABLED'
}
export enum EnumDatalensReportType {
  'chart' = 'chart',
  'dash' = 'dash'
}
export enum EnumDashboardType {
  'chart' = 'chart',
  'dash' = 'dash'
}
